import { createSlice } from '@reduxjs/toolkit'

interface MultiSelectState {
  isEnabled: boolean
}

const initialState: MultiSelectState = {
  isEnabled: true
}

const multiSelectSlice = createSlice({
  name: 'multiSelect',
  initialState,
  reducers: {
    enable: (state) => {
      state.isEnabled = true
    },
    disable: (state) => {
      state.isEnabled = false
    }
  }
})

export const { enable, disable } = multiSelectSlice.actions
export default multiSelectSlice.reducer

